import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [showSupport, setShowSupport] = useState(false);
  const { user } = useAuth();

  return (
    <>
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="container mx-auto px-4 py-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-gray-600">
              © {currentYear} Kessan. Todos los derechos reservados.
            </div>
            <div className="flex space-x-6 text-sm text-gray-600">
              <Link to="/help" className="hover:text-primary-600 transition-colors">
                Ayuda
              </Link>
              <button
                onClick={() => setShowSupport(true)}
                className="hover:text-primary-600 transition-colors"
              >
                Soporte
              </button>
              <Link to="/privacy" className="hover:text-primary-600 transition-colors">
                Privacidad
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Support Modal */}
      {showSupport && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4" role="dialog" aria-modal="true">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={() => setShowSupport(false)} />
          <div className="relative bg-white rounded-lg shadow-xl max-w-sm w-full p-6 text-center">
            <button
              onClick={() => setShowSupport(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              aria-label="Cerrar"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="mx-auto w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-4">
              <Mail className="h-6 w-6 text-primary-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">¿Necesitas ayuda?</h3>
            <div className="flex flex-col items-center gap-4">
              {user?.role === 'superadmin' ? (
                <p className="text-sm text-gray-600">
                  Revisa los logs del sistema o contacta al equipo de desarrollo.
                </p>
              ) : user?.role === 'admin' ? (
                <>
                  <p className="text-sm text-gray-600">
                    Si tienes problemas con tu cuenta o plan, escríbenos y te ayudaremos.
                  </p>
                  <a
                    href="mailto:soporte@kessan.cl"
                    className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700"
                  >
                    <Mail className="h-4 w-4" />
                    soporte@kessan.cl
                  </a>
                </>
              ) : (
                <>
                  <p className="text-sm text-gray-600">
                    Contacta al administrador de tu empresa para soporte con la plataforma.
                  </p>
                  <p className="text-xs text-gray-400">
                    Si el problema persiste, escribe a{' '}
                    <a href="mailto:soporte@kessan.cl" className="text-primary-600 hover:underline">soporte@kessan.cl</a>
                  </p>
                </>
              )}
              <button
                onClick={() => setShowSupport(false)}
                className="px-5 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
